module.exports = __webpack_public_path__ + "static/media/fumiko.2a77bc13.png";